import { Button } from "@chakra-ui/react";

import { StepDetailsBaseProps } from "../../models/StepDetailsBaseProps";
import { StepStateModel } from "../../models/StepModel";

 
export const PortfolioForwardCurvesStep = (props: StepDetailsBaseProps) => {
    const {
        colorScheme = 'blue', 
        className,
        style,
        children,
        saveActiveStepState,
        stepsSavedState,
        title,
        description,
        stepIdx,
        selectedStepOptionValue, // the value of the selected option
        stepOptions,
        setIsStepValid,
    } = props;



    const stepState: StepStateModel = { 
        stepIdx,
        selectedItems: [
            {itemTypeId: 2, itemId: 1, itemName: "FC 1"}, 
            {itemTypeId: 2, itemId: 4, itemName: "FC 4"}
        ], // the selected items for this step
    };


    const renderStepContent = () =>  {
        console.log({...props, stepsSavedState});

        return (
            <>
                <h4>{ `${props.title}` }</h4>

                <>
                    <p>Please select Forvard Curves:</p>
                    <ul>
                        <li>Selected: FC 1</li>
                        <li>FC 2</li>
                        <li>FC 3</li>
                        <li>Selected: FC 4</li>
                    </ul>
                </>
                
                <Button onClick={() => {
                    saveActiveStepState(stepIdx, stepState); 
                    setIsStepValid(true);
                    }}
                    >Simulating FCs are selected and valid</Button>

            </>
        );
    }

    return renderStepContent()
 
}


